import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { AuthContext } from '../contexts/AuthContext';
import { StoreContext } from '../contexts/StoreContext';

const STORE_API_URL = process.env.REACT_APP_API_URL;

function Waitlist() {
  const { token, isAuthenticated } = useContext(AuthContext);
  const [waitlist, setWaitlist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { stores, selectedStore, setSelectedStore, setStoreLocalStorage, setStoreLogo } = useContext(StoreContext);

  useEffect(() => {
    if (isAuthenticated && token) {
      // Fetch products when a store is selected
      if (selectedStore) {
        handleFetchWaitlist(selectedStore);
      }

    } else {
      console.log('Token is not available');
    }
  }, [token, selectedStore]);

  const handleFetchWaitlist = async (storeId) => {
    setLoading(true);

    console.log ('storeId: ' + storeId);

    try {
      const response = await fetch(`${STORE_API_URL}/waitlist/${storeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Error fetching purchases. Please check your authentication.');
      }

      const waitlistData = await response.json();
      setWaitlist(waitlistData);
    } catch (error) {
      setError(error.message);
      //toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleStoreChange = (e) => {
    const newStoreId = e.target.value;
    setSelectedStore(newStoreId);
    setStoreLocalStorage(newStoreId)

    const selected = stores.find(store => store._id === newStoreId);
    setStoreLogo(selected ? selected.logo : '');
  };

  const handleNotifyUsers = async (productId) => {
    // Show confirmation dialog before proceeding
    const userConfirmed = window.confirm('This will trigger a mass email notification Job. Do you want to proceed?');

    if (userConfirmed) {
      try {
        const response = await fetch(`${STORE_API_URL}/waitlist/notify/${productId}`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });
    
        // Check if the response is not OK
        if (!response.ok) {
          const errorData = await response.json(); // Parse the error message from the response
          const errorMessage = errorData.message || 'Error sending notifications'; // Use the error message from the backend or a fallback message
          //toast.error(errorMessage);
          throw new Error(errorMessage);
        } else {
          // Parse the response as JSON
          const data = await response.json();
    
          // Show the message from the response
          toast.success(data.message || 'Notification sent successfully!');
          handleFetchWaitlist(selectedStore);
        }
      } catch (error) {
        // Show the error message in the toast
        toast.error(error.message);
      }
    }
  };

  return (
    <Container>
      <ToastContainer />
      <div className="headline d-flex justify-content-between align-items-center">
        <h2 className="underline">Waitlist</h2>
        <div className="form-group">
          <label></label>
          <select
            id="storeSelect"
            className="form-select"
            value={selectedStore}
            onChange={handleStoreChange} // Use the handleStoreChange function
          >
            {stores.map((store) => (
              <option key={store._id} value={store._id}>
                {store.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="mb-3">
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: 'red' }}>{error}</div>}
      </div>
      {!loading && !error && waitlist.length > 0 && (
        <div className="row">
          {waitlist.map((product) => (
            <div className="col-md-12" key={product.product_id}>
              <div className="card mb-12" style={{ marginBottom: '10px' }}>
                <div className="card-body">
                  <div className="row">
                    <div className="col-lg-8 col-md-12" style={{ textAlign: 'left' }}>
                      <h5>{product.product_name}</h5>
                      <p>
                        Total Users on Waitlist: {product.total_users} <br />
                        Users unsubscribed from Waitlist: {product.notified_users}
                      </p>
                    </div>
                    <div className="col-lg-4 col-md-12" style={{ textAlign: 'right' }}>
                      <button 
                        onClick={() => handleNotifyUsers(product.product_id)} 
                        className="btn btn-primary me-2"
                      >
                        Notify Users
                      </button>
                      <Link 
                        to={`/waitlist/${product.product_id}`}
                        state={{ productName: product.product_name }} // Pass state directly
                        className="btn btn-primary"
                      >
                        View Waitlist
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="col-md-12">
        <div className="card mb-3 p-3" style={{ border: '2px solid #ff5722' }}>
          <div className="card-body">
            <h5 className="card-title" style={{ color: '#ff5722', fontWeight: 'bold' }}>Waitlist Notifier Rules</h5>
            <p>Look, we hate rules as much as you do, but to keep the nostalgia alive and avoid burn-in, here are a few things you need to know:</p>
            <ul className="ps-3">
              <li>You should connect your gmail account, so that emails can be sent from your account directly.</li>
              <li>Users are automatically unsubscribed from specific product notifications after making a purchase.</li>
              <li>Users can unsubscribe from notifications via the link in the email.</li>
              <li>Email notifications are suppressed for 48 hours per user per product to reduce spam.</li>
              <li>Improper use of this feature may lead to restrictions on your account.</li>
            </ul>
          </div>
        </div>
      </div>

    </Container>
  );
}

export default Waitlist;
